import { Button as BSButton, Modal } from 'react-bootstrap';

import { REQUIRE_TEAM_ON_UPLOAD } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features';
import { userHasPermissionToViewAnyProject } from '../../../helpers/permissions';
import SelectTeam from '../SelectTeam';
import type { Team } from '../../../../shared/model-typings';

type ModalTeamAssignmentProps = {
  show: boolean;
  onHide: () => void;
  allTeams: Team[];
  selectedTeams: Team[];
  onTeamsSelected: (teams: Team[]) => void;
  onTeamsSelectionImport: () => void;
};

const ModalTeamAssignment = (props: ModalTeamAssignmentProps) => {
  const isTeamRequired = useIsFeatureEnabled(REQUIRE_TEAM_ON_UPLOAD);
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <Modal.Title>
          Assign Project to Teams
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectTeam
          allTeams={props.allTeams}
          selectedTeams={props.selectedTeams}
          onTeamsSelected={props.onTeamsSelected}
          isRequired={isTeamRequired}
        />
      </Modal.Body>
      <Modal.Footer>
        <BSButton onClick={props.onHide}>Cancel</BSButton>
        <BSButton
          onClick={props.onTeamsSelectionImport}
          bsStyle="success"
          disabled={(!userHasPermissionToViewAnyProject() || isTeamRequired) && props.selectedTeams.length === 0}
        >
          Import Projects
        </BSButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTeamAssignment;
